// extracted by mini-css-extract-plugin
export default {"technology-list":"TechnologyList_technology-list__RMWUR"};